var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvelu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/quote-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quote-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.0675 8.7226H2.55C2.61 5.2201 3.3 4.6426 5.4525 3.3676C5.7 3.2176 5.7825 2.9026 5.6325 2.6476C5.49 2.4001 5.1675 2.3176 4.92 2.4676C2.385 3.9676 1.5 4.8826 1.5 9.2401V13.2826C1.5 14.5651 2.5425 15.6001 3.8175 15.6001H6.0675C7.3875 15.6001 8.385 14.6026 8.385 13.2826V11.0326C8.385 9.7201 7.3875 8.7226 6.0675 8.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1844 8.7226H10.6669C10.7269 5.2201 11.4169 4.6426 13.5694 3.3676C13.8169 3.2176 13.8994 2.9026 13.7494 2.6476C13.5994 2.4001 13.2844 2.3176 13.0294 2.4676C10.4944 3.9676 9.60938 4.8826 9.60938 9.2476V13.2901C9.60938 14.5726 10.6519 15.6076 11.9269 15.6076H14.1769C15.4969 15.6076 16.4944 14.6101 16.4944 13.2901V11.0401C16.5019 9.7201 15.5044 8.7226 14.1844 8.7226Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvelu);
export default __webpack_public_path__ + "static/media/evelu.7c16f10ea4adda914188464ddc6ca40f.svg";
export { ForwardRef as ReactComponent };